import { render, staticRenderFns } from "./deals.vue?vue&type=template&id=b9c4a4d2&scoped=true&"
import script from "./deals.vue?vue&type=script&lang=js&"
export * from "./deals.vue?vue&type=script&lang=js&"
import style0 from "./deals.vue?vue&type=style&index=0&id=b9c4a4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c4a4d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9c4a4d2')) {
      api.createRecord('b9c4a4d2', component.options)
    } else {
      api.reload('b9c4a4d2', component.options)
    }
    module.hot.accept("./deals.vue?vue&type=template&id=b9c4a4d2&scoped=true&", function () {
      api.rerender('b9c4a4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/account/deals.vue"
export default component.exports